import { atom } from "recoil";

export interface IActiveEmailListAtom {
  _id: string;
  name: string;
  emails: string[];
}

export const ActiveEmailListAtom = atom<IActiveEmailListAtom | null>({
  key: "ActiveEmailListAtom",
  default: null,
});
